import { AxiosResponse } from "axios";
import useSWR, { SWRResponse } from "swr";
import { ApiAccessObject, ApiResponseContainer } from "../../models/api";

let mutateFunction: ((id:string,data:any, revalidate?:boolean) => Promise<any>) | undefined;

export const MutationReference = {
  SetReference: (ref: any) => (mutateFunction = ref),
  GetReference: () => mutateFunction,
};

export function CreateAccessObject<R, H extends (...args: any) => any>(
  cacheId: string,
  Hook: H
): ApiAccessObject<R, H> {
  return {
    Hook,
    Mutate: (res, revalidate) =>
      MutationReference.GetReference()?.(cacheId, res, revalidate ?? true) ??
      Promise.resolve(),
  };
}

export function useExtendedApiAccess<T, E = Error>(
  cacheId: string,
  fetcher: (...param: any) => Promise<AxiosResponse<ApiResponseContainer<T>>>,
  onEvent?: {
    success?: (err: ApiResponseContainer<T>) => void;
    error?: (err: ApiResponseContainer<T>) => void;
  }
): SWRResponse<T | undefined, E> {
  const swr = useSWR<T | undefined, E>(cacheId, (...param: any) =>
    fetcher(...param)
      .then((res) => {
        if (res.data.isSuccess) {
          onEvent?.success?.(res.data);
          return res.data.data;
        } else {
          onEvent?.error?.(res.data);
        }
        return undefined;
      })
      .catch((e) => {
        const errData: ApiResponseContainer<T> = JSON.parse(e.message);
        onEvent?.error?.(errData);
        throw new Error(
          errData.message ??
            (Array.isArray(errData.errors)
              ? errData.errors?.join()
              : errData.errors
              ? Object.values(errData.errors).join()
              : "")
        );
      })
  );
  return swr;
}
